/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/unauthOneTimeCyberAgentScanMappers";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a UnauthOneTimeCyberAgentScan. */
export class UnauthOneTimeCyberAgentScan {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a UnauthOneTimeCyberAgentScan.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Returns unauthenticated one-time cyberagent scan status data.
   * @summary Returns unauthenticated one-time cyberagent scan status data.
   * @param [options] The optional parameters
   * @returns Promise<Models.UnauthOneTimeCyberAgentScanGetStatusDataResponse>
   */
  getStatusData(options?: Models.UnauthOneTimeCyberAgentScanGetStatusDataOptionalParams): Promise<Models.UnauthOneTimeCyberAgentScanGetStatusDataResponse>;
  /**
   * @param callback The callback
   */
  getStatusData(callback: coreHttp.ServiceCallback<Models.UnauthOneTimeCyberAgentScanStatusData>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getStatusData(options: Models.UnauthOneTimeCyberAgentScanGetStatusDataOptionalParams, callback: coreHttp.ServiceCallback<Models.UnauthOneTimeCyberAgentScanStatusData>): void;
  getStatusData(options?: Models.UnauthOneTimeCyberAgentScanGetStatusDataOptionalParams | coreHttp.ServiceCallback<Models.UnauthOneTimeCyberAgentScanStatusData>, callback?: coreHttp.ServiceCallback<Models.UnauthOneTimeCyberAgentScanStatusData>): Promise<Models.UnauthOneTimeCyberAgentScanGetStatusDataResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getStatusDataOperationSpec,
      callback) as Promise<Models.UnauthOneTimeCyberAgentScanGetStatusDataResponse>;
  }

  /**
   * Performs an unauthenticated one-time cyberagent scan and returns the baseline breaches
   * @summary Performs an unauthenticated one-time cyberagent scan and returns the baseline breaches.
   * @param [options] The optional parameters
   * @returns Promise<Models.UnauthOneTimeCyberAgentScanScanAndGetBreachesResponse>
   */
  scanAndGetBreaches(options?: Models.UnauthOneTimeCyberAgentScanScanAndGetBreachesOptionalParams): Promise<Models.UnauthOneTimeCyberAgentScanScanAndGetBreachesResponse>;
  /**
   * @param callback The callback
   */
  scanAndGetBreaches(callback: coreHttp.ServiceCallback<Models.BreachedDetail[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  scanAndGetBreaches(options: Models.UnauthOneTimeCyberAgentScanScanAndGetBreachesOptionalParams, callback: coreHttp.ServiceCallback<Models.BreachedDetail[]>): void;
  scanAndGetBreaches(options?: Models.UnauthOneTimeCyberAgentScanScanAndGetBreachesOptionalParams | coreHttp.ServiceCallback<Models.BreachedDetail[]>, callback?: coreHttp.ServiceCallback<Models.BreachedDetail[]>): Promise<Models.UnauthOneTimeCyberAgentScanScanAndGetBreachesResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      scanAndGetBreachesOperationSpec,
      callback) as Promise<Models.UnauthOneTimeCyberAgentScanScanAndGetBreachesResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getStatusDataOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/UnauthOneTimeCyberAgentScan/status",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.UnauthOneTimeCyberAgentScanStatusRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.UnauthOneTimeCyberAgentScanStatusData
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const scanAndGetBreachesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/UnauthOneTimeCyberAgentScan/scan",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.UnauthOneTimeCyberAgentScanRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BreachedDetail"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
